export enum TipoBeneficiario {
  TitularFuncionario,
  Dependente,
}
